<template>
  <div>
    <div class="row" v-if="isModular">
      <div class="form__col col col-xs-6">
        <date-gcr
          data-test-id="planned-production-start"
          id="planned-production-start"
          label="plannedProductionStart"
          :tooltip="$t('plannedProductionStartDesc')"
          v-model="plannedDates.productionStart"
          :validation-feedback="plannedProductionStartValidationFeedback"
        />
      </div>
    </div>
    <div class="row" v-if="isModular">
      <div class="form__col col col-xs-6">
        <date-gcr
          data-test-id="planned-production-end"
          id="planned-production-end"
          label="plannedProductionEnd"
          :tooltip="$t('plannedProductionEndDesc')"
          v-model="plannedDates.productionEnd"
          :validation-feedback="plannedProductionEndValidationFeedback"
        />
      </div>
    </div>
    <div class="row">
      <div class="form__col col col-xs-6">
        <date-gcr
          data-test-id="planned-start"
          id="planned-start"
          :label="plannedStart"
          :tooltip="isModular ? $t('plannedStartDescModular') : $t('plannedStartDesc')"
          v-model="plannedDates.start"
          :validation-feedback="plannedStartValidationFeedback"
        />
      </div>
    </div>
    <div class="row" v-if="!isModular">
      <div class="form__col col col-xs-6">
        <date-gcr
          data-test-id="planned-inside-wall-coverings"
          id="planned-inside-wall-coverings"
          label="plannedInsideWallCoverings"
          :tooltip="$t('plannedInsideWallCoveringsDesc')"
          v-model="plannedDates.insideWallCoverings"
          :validation-feedback="plannedInsideWallCoveringsValidationFeedback"
        />
      </div>
    </div>
    <div class="row">
      <div class="form__col col col-xs-6">
        <date-gcr
          data-test-id="planned-end"
          id="planned-end"
          :label="plannedEnd"
          :tooltip="$t('plannedEndDesc')"
          v-model="plannedDates.end"
          :validation-feedback="plannedEndValidationFeedback"
        />
      </div>
    </div>

    <div
      class="important-note"
      data-test-id="builduing-planned-date-important-note"
      v-html="$t('builduingPlannedDateImportantNote')"
      v-if="!isModular"
    ></div>
  </div>
</template>

<script>
import DateGcr from '@/components/atoms/Date'
import Validators from '@/_helpers/validators'
import '@/utilities/noteImportante/important-note.scss'

export default {
  components: { DateGcr },
  props: {
    plannedDates: Object,
    isModular: Boolean
  },
  computed: {
    plannedStartValidationFeedback() {
      return Validators.optionalDateIsAfterOrEqual(this.plannedDates.start, '2015-01-01', this.$t('invalidPlannedDate2015'))
    },
    plannedInsideWallCoveringsValidationFeedback() {
      return (
        Validators.optionalDateIsAfterOrEqual(
          this.plannedDates.insideWallCoverings,
          '2015-01-01',
          this.$t('invalidPlannedDate2015')
        ) ||
        Validators.optionalDateIsBetweenInclusive(
          this.plannedDates.insideWallCoverings,
          this.plannedDates.start,
          this.plannedDates.end,
          this.$t('invalidInsideWallCoverings')
        )
      )
    },
    plannedEndValidationFeedback() {
      return (
        Validators.optionalDateIsAfterOrEqual(this.plannedDates.end, '2015-01-01', this.$t('invalidPlannedDate2015')) ||
        Validators.optionalDateIsBeforeOrEqual(this.plannedDates.start, this.plannedDates.end, this.$t('invalidPlannedEnd'))
      )
    },
    plannedProductionStartValidationFeedback() {
      return Validators.optionalDateIsAfterOrEqual(
        this.plannedDates.productionStart,
        '2015-01-01',
        this.$t('invalidPlannedDate2015')
      )
    },
    plannedProductionEndValidationFeedback() {
      return (
        Validators.optionalDateIsAfterOrEqual(this.plannedDates.productionEnd, '2015-01-01', this.$t('invalidPlannedDate2015')) ||
        Validators.optionalDateIsBeforeOrEqual(
          this.plannedDates.productionStart,
          this.plannedDates.productionEnd,
          this.$t('invalidPlannedProductionEnd')
        )
      )
    },
    plannedStart() {
      if (this.isModular) return 'plannedConstructionSiteStart'
      else return 'plannedStart'
    },
    plannedEnd() {
      if (this.isModular) return 'plannedConstructionSiteEnd'
      else return 'plannedEnd'
    }
  }
}
</script>
